var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ax-avatar",attrs:{"title":!_vm.hideTitle ? _vm.title : ''}},[(_vm.isDefaultAvatar)?_c('AxUserAvatarDefault',{style:(_vm.style),attrs:{"title":_vm.title,"email-name":_vm.emailName}}):_c('img',{staticClass:"ax-avatar_image",style:(_vm.style),attrs:{"src":_vm.profileImgResolved,"alt":"avatar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }